import React, { useContext, useState } from 'react';
import { Button, Radio } from '@/shared/components';
import LanguageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';
import { useMutationExportOrder } from '@/hooks/orderhistory.hook';

interface IProps {
  searchParams: Object;
  sortParams: Object;
  pageSize: number;
  pageNumber: number;
}
export default function ExportOrders(props: IProps) {
  const { lang } = useContext(LanguageContext);
  const { t } = useTranslation(lang, 'orderhistory');
  const { searchParams, sortParams, pageSize, pageNumber } = props;
  const [exportSelector, setExportSelector] = useState<string>('');
  const { mutateAsync } = useMutationExportOrder();

  const exportOrder = () => {
    const excelFlag = exportSelector === 'xls' ? true : false;
    const submitReq = {
      excelFlag: excelFlag,
      ...(searchParams && { advanceSearchParams: searchParams }),
      ...(sortParams && { orderBy: sortParams }),
      pageSize: pageSize,
      pageNumber: pageNumber,
    };
    mutateAsync(submitReq).then((blob: any) => {
      const fileName = 'order_report';
      if (!Blob) {
        console.log('.....download not supported....');
      }
      const blobUrl = window.URL.createObjectURL(
        new Blob([blob], {
          type: (exportSelector === 'xls' ? 'application/vnd.ms-excel' : 'text/csv') + ';charset=utf-8',
        })
      );
      const link = document.createElement('a');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.href = blobUrl;
      if ('download' in link) {
        link.download = fileName;
        console.log('.....download supported....');
      } else {
        console.log('.....download not supported....');
      }
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 4e4);
    });
  };
  return (
    <div id="export-orders" className="flex ml-auto items-center sm:inline-flex sm:flex-col sm:ml-0 sm:items-start">
      <div className="flex mr-2">{t('export.orders.as')}</div>
      <div className="flex items-center">
        <div className="flex">
          <Radio
            value="xls"
            name="export-selector"
            checked={exportSelector === 'xls' ? true : false}
            onChange={(e) => {
              setExportSelector(e.target.value);
            }}
          >
            {t('xls')}
          </Radio>
          <Radio
            value="csv"
            name="export-selector"
            checked={exportSelector === 'csv' ? true : false}
            onChange={(e) => {
              setExportSelector(e.target.value);
            }}
          >
            {t('csv')}
          </Radio>
        </div>
        <Button
          label={t('export')}
          onClick={() => {
            exportOrder();
          }}
          disabled={exportSelector === ''}
          type="outline"
        />
      </div>
    </div>
  );
}
